// creating the current date to be set as the inital date on date input types
export const initalDate = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();

  return `${yyyy}-${mm}-${dd}`;
};

// Calculate the credit based on the loan age
export const calculateCredit = loanAge => {
  if (loanAge <= 4) return 0.5;
  if (loanAge > 4 && loanAge <= 8) return 0.25;
  return 0;
};

// object for lookup up premiums (effective March 1, 2026)
export const premiumLookup = {
  25000: 308,
  30000: 339,
  35000: 371,
  40000: 401,
  45000: 434,
  50000: 465,
  55000: 496,
  60000: 529,
  65000: 560,
  70000: 592,
  75000: 625,
  80000: 655,
  85000: 687,
  90000: 718,
  95000: 751,
  100000: 780,
};

// Look up the premium
function lookupPremium(value) {
  const val = Number(value) + 4999;
  for (let price in premiumLookup) {
    if (price == 100000) {
      return premiumLookup[price];
    } else if (price > val) {
      return premiumLookup[price - 5000];
    }
  }
}

// Calculate the premium (effective March 1, 2026)
export const calculatePremium = amt => {
  if (amt >= 25000 && amt <= 100000) {
    return lookupPremium(amt);
  } else if (amt > 100000 && amt <= 1000000) {
    return Math.round((amt - 100000) * 0.00494 + 780);
  } else if (amt > 1000000 && amt <= 5000000) {
    return Math.round((amt - 1000000) * 0.00406 + 5226);
  } else if (amt > 5000000 && amt <= 15000000) {
    return Math.round((amt - 5000000) * 0.00335 + 21466);
  } else if (amt > 15000000 && amt <= 25000000) {
    return Math.round((amt - 15000000) * 0.00238 + 54966);
  } else if (amt > 25000000 && amt <= 50000000) {
    return Math.round((amt - 25000000) * 0.00143 + 78766);
  } else if (amt > 50000000 && amt <= 100000000) {
    return Math.round((amt - 50000000) * 0.00129 + 114516);
  } else if (amt > 100000000) {
    return Math.round((amt - 100000000) * 0.00116 + 179016);
  } else {
    return 0;
  }
};

//format number as currency
export const formatCurrency = value => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
};

//format number as thousands
export const formatThousands = value => {
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
  });
  return formatter.format(value);
};

//format number as percent
export const formatPercentage = value =>
  value ? `${Number(value) * 100}%` : '';

// show name of upload for custom file inputs
export const findFileName = () => {
  $('input[type="file"]').change(function() {
    $('#file-input').text(this.files[0].name);
  });
};
